// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPublicV1GetOrCreateChatRequestSchema {
  /** JSON query **/
  jsonQuery?: object;
  /** URL страницы, с которой был инициирован чат **/
  pageUrl?: string;
  /** Страница, с которой был инициирован чат **/
  sourcePage?: ESourcePage;
}

export enum ESourcePage {
  /** Список чатов **/
  'ChatsList' = 'chatsList',
  /** Циан Помощник **/
  'CianAssistant' = 'cianAssistant',
  /** Карточка новостройки **/
  'NewbuildingCard' = 'newbuildingCard',
  /** Выдача новостроек **/
  'NewbuildingsList' = 'newbuildingsList',
  /** Карточка объявления **/
  'OfferCard' = 'offerCard',
  /** Выдача объявлений **/
  'OffersList' = 'offersList',
}
